var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54939)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.85195C26.8404 9.85036 25.792 9.41509 25.0189 8.6416C24.2458 7.86811 23.8111 6.81956 23.81 5.72595V0.00195312H5.38199C3.9546 0.00195312 2.58568 0.568975 1.57635 1.5783C0.567034 2.58762 0 3.95656 0 5.38396V37.8279C0.00211967 39.254 0.570084 40.6208 1.57917 41.6284C2.58827 42.636 3.95598 43.202 5.38199 43.2019H27.504C28.93 43.202 30.2977 42.636 31.3068 41.6284C32.3159 40.6208 32.8839 39.254 32.886 37.8279V9.85195H27.934Z",
    fill: "#BA4E41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8861 9.85195H27.9341C26.8404 9.85036 25.7921 9.41509 25.019 8.6416C24.2459 7.86811 23.8111 6.81956 23.8101 5.72595V0.00195312L32.8861 9.85195Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7879 34.124H11.7799C10.0059 34.124 8.56787 35.562 8.56787 37.336V44.792C8.56787 46.5659 10.0059 48.004 11.7799 48.004H36.7879C38.5618 48.004 39.9999 46.5659 39.9999 44.792V37.336C39.9999 35.562 38.5618 34.124 36.7879 34.124Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4699 42.6779V44.132H16.9639V42.6779H18.4699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.732 42.958H23.386V44.132H19.116V43.026L21.728 39.284H19.15V38.118H23.37V39.224L20.732 42.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7341 38.118V44.132H24.2861V38.118H25.7341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.192 42.022V44.132H26.738V38.118H29.086C29.8 38.118 30.346 38.294 30.72 38.65C30.9094 38.8355 31.0574 39.059 31.1542 39.3058C31.2511 39.5526 31.2946 39.8171 31.282 40.082C31.2883 40.4318 31.2013 40.7769 31.03 41.082C30.8554 41.3802 30.5966 41.6203 30.286 41.772C29.9112 41.9482 29.5001 42.0338 29.086 42.022H28.192ZM29.808 40.082C29.808 39.5553 29.516 39.2886 28.932 39.282H28.192V40.846H28.932C29.516 40.8526 29.808 40.598 29.808 40.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4401 30.5059C15.7674 30.5049 15.1227 30.2371 14.6473 29.7613C14.1719 29.2855 13.9046 28.6405 13.9041 27.9679V25.4299H18.9781V27.9679C18.9775 28.6409 18.7099 29.2861 18.2341 29.762C17.7582 30.2379 17.113 30.5054 16.4401 30.5059ZM15.2021 26.7279V27.9679C15.2021 28.2965 15.3324 28.6116 15.5645 28.8441C15.7966 29.0765 16.1115 29.2074 16.4401 29.2079C16.7688 29.2074 17.0838 29.0766 17.3163 28.8442C17.5487 28.6117 17.6795 28.2966 17.68 27.9679V26.7279H15.2021Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9021 25.432H16.446V22.888H13.9021V25.432Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4399 22.8899H18.9839V20.3459H16.4399V22.8899Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9021 20.3479H16.446V17.804H13.9021V20.3479Z",
    fill: "#BA4E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4399 17.806H18.9839V15.262H16.4399V17.806Z",
    fill: "#BA4E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48.002,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.df063f5beaa0399d5669403ff1e20c33.svg";
export { ForwardRef as ReactComponent };